// page animation
//import WOW from "wowjs";
import "../../../assets/css/animate.css";
// icon image
import QuoteIcon from "../../../assets/images/icons/qoute-icon.png";



const AboutWrapper = () => {

  return (
    <>
      {/* =============== About wrapper start =============== */}
      <div className="about-wrapper mt-96">
        <div className="container">
          <div className="about-company">
            <div className="row">
              <div className="col-lg-12">
                <div className="company-info">
                  <h5>A propos de Masjidy</h5>
                  <h2>
                    La mosquée au cœur de votre quotidien
                  </h2>
                  <p>
                    Depuis les débuts de l’Islam, la mosquée a toujours été bien plus qu’un simple lieu de prière. Dès l’époque du Prophète ﷺ, elle était un centre de savoir, un espace de rencontre, un lieu d’entraide et d’organisation pour la communauté. C’est dans la mosquée que les premières générations de musulmans se formaient, débattaient des affaires de la société et renforçaient leur foi ensemble.
                  </p>
                  <p>
Aujourd’hui, dans un monde connecté où l’information circule rapidement, il est essentiel de retrouver ce lien avec nos mosquées et de profiter pleinement de ce qu’elles offrent. Masjidy a été conçu pour répondre à ce besoin : une plateforme moderne qui vous permet de suivre les activités de votre mosquée, d’accéder facilement aux événements organisés et de ne plus jamais manquer une opportunité de vous enrichir spirituellement.
                  </p>

                  <h3 className="mt-4 mb-3">Pourquoi utiliser Masjidy ?</h3>
                  <ul className="feature-list">
                    <li>
                      <span className="emoji">🔹</span> <strong>Restez informé(e) en un clic :</strong> Consultez le programme des conférences, cours, ateliers et autres événements qui se déroulent dans votre mosquée.
                    </li>
                    <li>
                      <span className="emoji">🔹</span> <strong>Tissez des liens avec votre communauté :</strong> Participez aux forums, aux journées portes ouvertes et aux initiatives locales qui renforcent la fraternité et l'entraide.
                    </li>
                    <li>
                      <span className="emoji">🔹</span> <strong>Ne ratez aucun moment important :</strong> Recevez des rappels et notifications pour être sûr(e) d'être présent(e) aux événements qui vous tiennent à cœur.
                    </li>
                    <li>
                      <span className="emoji">🔹</span> <strong>Un accès facile et rapide :</strong> Plus besoin de chercher l'information sur différentes plateformes ou d'attendre les annonces après la prière. Tout est centralisé sur Masjidy !
                    </li>
                  </ul>

                  
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="company-mini-gallary">
                  <div className="Gallary-item1 Gallary-item">
                    <img src={MiniGallary1}  alt="Imgs" className="img-fluid" />
                  </div>
                  <div className="Gallary-item2 Gallary-item">
                    <img src={MiniGallary2}  alt="Imgs" className="img-fluid" />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className="about-history position-relative mt-120">
            <h3 className="float-title position-absolute">Masjidy Story</h3>
            <div className="qoute-icon position-absolute">
              <img src={QuoteIcon}  alt="Imgs" />
            </div>
            
            <h4 className="story-subtitle">Masjidy : L'histoire d'une idée devenue une mission</h4>
            
            <p>
              Tout a commencé par une simple frustration partagée entre amis : « Pourquoi est-il si difficile de suivre les activités des mosquées ? »
            </p>

            <p>
              Il était courant de manquer une conférence intéressante, un atelier enrichissant ou encore une action solidaire importante, simplement parce que l'information était dispersée entre les annonces après la prière, les affiches à l'entrée ou des messages échangés sur différents groupes.
            </p>

            <p>
              Et si nous avions une seule plateforme qui centralise tout ? Une solution simple, moderne, accessible à tous, qui permettrait à chaque fidèle de rester connecté à sa mosquée et de profiter pleinement des événements proposés. C'est ainsi que Masjidy est né.
            </p>

            <h5 className="story-section-title">D'une idée entre amis à une plateforme au service de tous</h5>
            
            <p>
              L'idée nous enthousiasmait, mais encore fallait-il la concrétiser. Nous avons commencé par en parler entre nous et le verdict était unanime : il manquait un outil fiable pour diffuser et recevoir l'information sur les activités des mosquées.
            </p>

            <p>
              Petit à petit, l'équipe s'est formée. Développement, design, communication… Chacun a mis ses compétences au service de cette ambition commune : faciliter la connexion entre les musulmans et leurs mosquées.
            </p>

            <p>
              Après des mois de travail, Masjidy est devenu une réalité : une plateforme qui permet à chacun de retrouver en un clic les événements de sa mosquée, des mosquées, de recevoir des notifications sur les conférences, les forums, les ateliers et de vivre pleinement l'expérience de la mosquée, même au-delà des heures de prière.
            </p>
          </div>
        </div>
      </div>
      {/* =============== About wrapper end =============== */}
    </>
  );
}

export default AboutWrapper;
